import { render, staticRenderFns } from "./PointBitcashError.vue?vue&type=template&id=45270e4d"
import script from "./PointBitcashError.vue?vue&type=script&lang=js"
export * from "./PointBitcashError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports